'use client';

import { useSession } from '@shared/auth';
import { Skeleton } from '@shared/components/shadcn';
import { Success } from '@shared/icons';
import { useTranslations } from 'next-intl';

function ThankYouSuccessBanner() {
  const t = useTranslations('thank_you');
  const { session, isLoading } = useSession();
  const playerProfile = session.profile;
  const isLoadingProfile = isLoading;

  return (
    <div
      className="flex w-full items-center gap-3 rounded-xl border border-border p-4 bg-accent-green/10 dark:bg-accent-green/10"
      data-testid="thank-you-success-banner"
      data-track-container="Notification"
      data-track-type="Order Confirmation"
    >
      <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-[4px] bg-accent-green">
        <Success size="small" className="text-foreground dark:text-foreground-inverse" data-testid="thank-you-success-icon" />
      </div>
      <div className="flex min-w-0 flex-col gap-1">
        {isLoadingProfile ? (
          <Skeleton className="h-6 w-48" data-testid="thank-you-success-title-skeleton" />
        ) : (
          <p className="paragraph-strong break-all" data-testid="thank-you-success-title">
            {t.rich('success_banner.title', {
              firstName: playerProfile?.firstName ?? '',
              mask: chunks => <span data-track-privacy="Mask">{chunks}</span>,
            })}
          </p>
        )}
        <p className="paragraph-explanatory" data-testid="thank-you-success-subtitle">
          {t('success_banner.subtitle')}
        </p>
      </div>
    </div>
  );
}

export { ThankYouSuccessBanner };
